<template>
  <okendo-reviews-widget
    class="c-reviews-widget"
    :product-id="shopifyProductId"
  />
</template>

<script>
import get from 'lodash/get'
import { OkendoReviewsWidget } from '@okendo/okendo-widgets-vue'
export default {
  components: {
    OkendoReviewsWidget
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    shopifyProductId() {
      return get(this.product, 'pimSyncSourceProductId')
    }
  }
}
</script>

<style lang="scss">
.c-reviews-widget {}
</style>
